import React from "react";
import type { TypedWrappedFieldProps } from "redux-form";
import { touch } from "redux-form";
import _ from "underscore";

import type { MenuSelectProps } from "@braintrust/braintrust-ui-components";
import { MenuSelect } from "@braintrust/braintrust-ui-components";

type MenuSelectFieldProps<TValue extends string = string> = Omit<
  MenuSelectProps,
  "value" | "onChange" | "multiple"
> &
  TypedWrappedFieldProps<TValue>;

export const MenuSelectField = <TValue extends string>({
  input,
  meta,
  options,
  preventUnselect,
  ...props
}: MenuSelectFieldProps<TValue>) => {
  const isEqualToInitial = (value: unknown) => {
    const noInitial = !meta.initial || !meta.initial.length;
    const valueNotSelected = !value;

    if (noInitial && valueNotSelected) return true;

    return _.isEqual(value, meta.initial);
  };

  return (
    <MenuSelect
      {...props}
      value={input.value}
      onChange={(value) => {
        meta.dispatch(touch(meta.form, input.name));
        input.onChange(isEqualToInitial(value) ? meta.initial : value);
      }}
      options={options}
      preventUnselect={preventUnselect}
    />
  );
};
